import { createRoot } from 'react-dom/client';
import React from 'react';
import PaymentPage from "./PaymentPage";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";

export default (() => {

    const init = () => {
        const appPayment = document.getElementById("appPayment");
        if (!appPayment) {
            return;
        }
        const paymentData = JSON.parse(appPayment.dataset.appPayment);


        const stripePromise = loadStripe(paymentData.publishableKey);
        const appearance = {
            theme: 'stripe'
        };

        const options = {
            clientSecret: paymentData.clientSecret,
            appearance
        };


        const root = createRoot(appPayment);

        root.render(<Elements stripe={stripePromise} options={options}>
            <PaymentPage paymentData={paymentData} stripe={stripePromise} />
        </Elements>); 
    };

    return {
        init: init
    };
})();


